module.exports = __webpack_public_path__ + "static/img/23.fbf27f5.png";


//////////////////
// WEBPACK FOOTER
// ./static/image/23.png
// module id = 66
// module chunks = 1 2 3 4 5 6 7 8